import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeamLeadHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/team-lead'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'team_lead_tools',
          component: TeamLeadHome,
          meta: { permissions: ['administrator', 'team_lead'] },
        },
      ],
    },
  ],
};
